<template>
  <div class="container-xxl pb-5 placeholder-glow">
    <div class="accordion" id="accordionExample">
      <template v-if="!ativa_placeholder">
        <div class="accordion-item" v-for="(d, i) in dados" :key="i">
          <h2 class="accordion-header">
            <button :class="['accordion-button', i == 0 ? '' : 'collapsed']" type="button" data-bs-toggle="collapse"
              :data-bs-target="'#acord' + i" aria-expanded="true" :aria-controls="i">
              <strong>
                {{ d.titulo }}
              </strong>
            </button>
          </h2>
          <div :id="'acord' + i" :class="['accordion-collapse', 'collapse', i == 0 ? 'show' : '']"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div  v-html="d.texto"></div>
              <div>
                <ListaArquivos :dados_arquivos_aula="d.lista_arquivo" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <span class="col-12 placeholder" style="height: 50px" :class="class_placeholder" v-if="ativa_placeholder"></span>
      </template>
    </div>
  </div>
</template>

<script>
import ListaArquivos from './ListaArquivos.vue';
export default {
  name: "Acordeon",
  components: {ListaArquivos},
  props: {
    dados: {
      default: [
      {
        titulo: "Eleitor Consciente",
        texto: `Esse é o eleitor que passou pela palestra sobre a diferença da velha e da nova política, é aquele eleitor que entendeu a importancia de não vender o voto e vota pensando no coletivo e não em ganhos pessoais.`,
      },
      {
        titulo: "Eleitor Multiplicador",
        texto: `O Eleitor Multiplicador é aquele que já tem consciencia para votar, já entendeu a importancia de definir quem é o contratado e quem é o contratante e agora quer ajudar a construir a base política, pois sabe da importancia de construir o tripé eleitoral.`,
      },
      {
        titulo: "Eleitor +",
        texto: `O Eleitor+ é aquele aue já entendeu a importancia de montar um grupo capaz de eleger um candidato comprometido com seus eleitores. Ele sabe que precisamos sustentar esse projeto e viabilizar a campanha do início ao fim para que o candidato escolhido entenda realmente quem é o contratante e quem é o prestador de serviço.`,
      },
      {
        titulo: "Eleitor Líder",
        texto: `O Eleitor Liderança é aquele que já assimilou todos esses processos e tem tempo disponível para se doar ficando à frente de alguma de nossas ações, seja liderando um núcleo, liderando um projeto, ou até mesmo vindo como candidato.`,
      },
    ]},
    ativa_placeholder: {
      default: false
    }
  },
  data() {
    return {

    };
  },
};
</script>

<style scoped></style>